import { render, createRoot } from 'react-dom'
import {AccreditationUI} from "./AccreditationUI";
import {AgencyUI} from "./AgencyUI";
import {CsvExport} from "./components/csv-export/CsvExport";
import {EarnedAccreditationRepeater} from "./components/earned-accred-repeater/EarnedAccreditationRepeater";
import {RecurringIntervalConditions} from "./components/date/RecurringIntervalConditions";
import {IssuanceTrainingCodes} from "./components/accreditation/IssuanceTrainingCodes";
import {IssuanceEarnedPoints} from "./components/accreditation/IssuanceEarnedPoints";
import {RepeaterSelect} from "./components/RepeaterSelect";
import {SettingsEarningEvents} from "./SettingsEarningEvents";
import {EarningEventFields} from "./components/earning-events/EarningEventFields";
import {labelValueArrayToObject} from "./util";
import {ContentEarningEvents} from "./ContentEarningEvents";
import {FieldInstances} from "./components/FieldInstances";
import {DeleteEarnedAccredButton} from "./components/delete-earned-accred/DeleteEarnedAccredButton";
import {ConfirmationModal} from "./components/delete-earned-accred/ConfirmationModal";
import {ContentAccreditationAttributes} from "./components/content/ContentAccreditationAttributes";
import {CheckboxMultiselect} from "./components/CheckboxMultiselect";


export const renderFields = () => {

  window.addEventListener('load', () => {
    if ( window.tangibleFields === undefined ) return

    tangibleFields.types.add('recurringIntervalConditions', RecurringIntervalConditions);
    tangibleFields.types.add('issuanceEarnedPoints', IssuanceEarnedPoints);
    tangibleFields.types.add('issuanceTrainingCodes', IssuanceTrainingCodes);
    tangibleFields.types.add('repeaterSelect', RepeaterSelect);
    tangibleFields.types.add('checkboxMultiselect', CheckboxMultiselect);
    tangibleFields.types.add('earningEventFields', EarningEventFields);
    tangibleFields.types.add('fieldInstances', FieldInstances);

    // Agency UI
    const agencyUI = document.querySelectorAll('.tgbl_agency_admin_ui')
    for ( const elem of agencyUI ) {
      const component = <AgencyUI value={elem.dataset.value} />

      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())

      createRoot
        ? createRoot(elem).render(component)
        : render(component, elem)
    }

    // Accreditation UI
    const accreditationUI = document.querySelectorAll('.tgbl_accreditation_admin_ui')
    for ( const elem of accreditationUI ) {
      const component = <AccreditationUI
        value={elem.dataset.value}
        contentChoices={elem.dataset.content_choices}
        agencies={elem.dataset.agencies}
      />

      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())

      createRoot
        ? createRoot(elem).render(component)
        : render(component, elem)
    }

    // Earned Accreditation Form Repeater
    const earnedAccreditationRepeater = document.querySelectorAll('.tgbl_earned_accreditation_repeater')
    for ( const elem of earnedAccreditationRepeater ) {
      const component = <EarnedAccreditationRepeater/>
      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(elem).render(component)
        : render(component, elem)
    }

    // Settings, earning events
    const earningEventsContainer = document.querySelector('#tgbl_settings_earning_events');
    if( earningEventsContainer ) {

      const component = <SettingsEarningEvents
        earningEvents={ earningEventsContainer.dataset.earning_events }
        contentChoices={ JSON.parse(earningEventsContainer.dataset.content_choices) }
        pointTypes={ labelValueArrayToObject(JSON.parse(earningEventsContainer.dataset.point_types)) }
      />

      createRoot
        ? createRoot(earningEventsContainer).render(component)
        : render(component, earningEventsContainer)

    }

    // Content, earning events
    const contentDefaultAccreditationValues = document.querySelectorAll('.tgbl-content-default-accreditation-values')
    for ( const elem of contentDefaultAccreditationValues ) {
      const component = <ContentEarningEvents
        contentRules={ JSON.parse( elem.dataset.content_type_rules) }
        contentAccreditationValues={ JSON.parse(elem.dataset.content_accreditation_values) }
      />
      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(elem).render(component)
        : render(component, elem)
    }

    // Content, accreditation relations
    const contentAccreditations = document.querySelectorAll('.tgbl-content-accreditations')
    for ( const elem of contentAccreditations ) {
      const component = <ContentAccreditationAttributes
        contentAccreditations={ JSON.parse( elem.dataset.content_accreditations) }
        contentEvents={ JSON.parse(elem.dataset.content_events) }
        contentAccreditationData={ JSON.parse(elem.dataset.content_accreditation_data)}
      />
      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot(elem).render(component)
        : render(component, elem)
    }

    // Delete earned accreditation
    const deleteEarnedAccred = document.querySelectorAll('.tgbl_delete_earned_accreditation')
    if ( deleteEarnedAccred.length ) {
      // Create single modal for page
      const modalContainer = document.createElement("DIV")
      modalContainer.className = "tgbl-interface"
      const modal = <ConfirmationModal/>
      // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
      createRoot
        ? createRoot( document.body.appendChild(modalContainer) ).render(modal)
        : render( modal, document.body.appendChild(modalContainer) )

      // Create individual action buttons
      for ( const elem of deleteEarnedAccred ) {
        const component = <DeleteEarnedAccredButton id={elem.dataset.id}/>

        createRoot
          ? createRoot(elem).render(component)
          : render(component, elem)
      }
    }


    // CSV Export
    // const csvExports = document.querySelectorAll('.tgbl_earned_accreditations_csv_export')
    // for ( const elem of csvExports ) {
    //   const component = <CsvExport
    //     value={elem.dataset.value}
    //     objectID={elem.dataset.object_id}
    //     csvColumns={elem.dataset.columns}
    //     postType={elem.dataset.post_type} />
    //
    //   // React 18 is used since WP 6.2 (createRoot() need to be used instead of render())
    //
    //   createRoot
    //     ? createRoot(elem).render(component)
    //     : render(component, elem)
    // }

  })
}

